import { render, staticRenderFns } from "./LastWeekActionsView.vue?vue&type=template&id=65cc67c9"
import script from "./LastWeekActionsView.vue?vue&type=script&lang=js"
export * from "./LastWeekActionsView.vue?vue&type=script&lang=js"
import style0 from "./LastWeekActionsView.vue?vue&type=style&index=0&id=65cc67c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports